import { FETCH_COACH, RESET_AVAILABLE_DATES, FETCH_AVAILABLE_DATES, FETCH_AVAILABLE_TIMES } from './types';

export default {
    [FETCH_COACH](state, payload) {
        state.coach = payload;
    },
    [RESET_AVAILABLE_DATES](state) {
        state.available_dates = [];
        state.last_available_date = 'today';
    },
    [FETCH_AVAILABLE_DATES](state, payload) {
        if (Array.isArray(payload) && payload.length) {
            state.available_dates.push(...payload);
            state.last_available_date = payload.slice(-1)[0].date;
        }
    },
    [FETCH_AVAILABLE_TIMES](state, payload) {
        state.available_times = payload.available_times;
        state.available_timespans = payload.available_timespans;
        state.available_timespan_count = payload.available_timespan_count;
    },
};



// WEBPACK FOOTER //
// ./src/store/coach/mutations.js